import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Form, Button, Card, Alert } from "react-bootstrap";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";

const AddManualAttendancePage = () => {
  const [formData, setFormData] = useState({
    employee_id: null,
    date: new Date().toISOString().split("T")[0],
    check_in: "09:00",
    check_out: "17:00",
  });
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Dummy employee list (replace with API call in production)
  const dummyEmployees = [
    { id: 1, name: "John Doe" },
    { id: 2, name: "Jane Smith" },
    { id: 3, name: "Alice Johnson" },
    { id: 4, name: "Bob Williams" },
  ];

  // Fetch employees (using dummy data for now)
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        // Placeholder for API call
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) throw new Error("User not found in localStorage");
        const response = await axios.get(`${API_URL_LOCAL}/api/employee/fetch/${user.id}`);
        const formatted = response.data.employees.map((e)=>({
          name : e.first_name + ' ' + e.last_name,
          id:e.id
        }))
        
        setEmployees(formatted);
        // setEmployees(dummyEmployees);
      } catch (err) {
        setError("Failed to load employees: " + err.message);
      }
    };
    fetchEmployees();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle employee selection
  const handleEmployeeChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, employee_id: selectedOption ? selectedOption.value : null }));
  };

  // Validate form
  const validateForm = () => {
    if (!formData.employee_id) return "Please select an employee.";
    if (!formData.date) return "Please select an date.";
    if (!formData.check_in) return "Please enter check-in time.";
    if (!formData.check_out) return "Please enter check-out time.";
    const checkInTime = new Date(`1970-01-01T${formData.check_in}:00`);
    const checkOutTime = new Date(`1970-01-01T${formData.check_out}:00`);
    if (checkOutTime <= checkInTime) return "Check-out time must be after check-in time.";
    return null;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    // setLoading(true);
    try {
      const payload = {
        emp_id: formData.employee_id,
        date: formData.date,
        check_in_time: `${formData.date}T${formData.check_in}:00Z`,
        check_out_time: `${formData.date}T${formData.check_out}:00Z`,
        location_for_in: `Office`,
        location_for_out: `Office`,
        token_device: 'By Manual',

      };
      // Placeholder API call
      const response = await axios.post(`${API_URL_LOCAL}/api/attendance/mark-manual`, payload);
      if (response.status === 200) {
      setSuccess("Attendance added successfully!");
      setFormData({
        employee_id: null,
        date: new Date().toISOString().split("T")[0],
        check_in: "09:00",
        check_out: "17:00",
      });
      } else {
        throw new Error("Failed to add attendance");
      }
    } catch (err) {
      setError("Failed to add attendance: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // react-select options
  const employeeOptions = employees.map((emp) => ({
    value: emp.id,
    label: emp.name,
  }));

  return (
    <MasterLayout>
      <Breadcrumb title="Add Manual Attendance" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24 d-flex justify-content-center align-items-center">
          <div className="w-100" style={{ maxWidth: "500px" }}>
            <h6 className="fw-semibold text-primary-dark mb-20">
              Add Manual Attendance
            </h6>
            {error && (
              <Alert variant="danger" className="bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
                {error}
              </Alert>
            )}
            {success && (
              <Alert variant="success" className="bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
                {success}
              </Alert>
            )}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-20">
                <Form.Label className="fw-medium text-primary-dark">
                  Employee
                </Form.Label>
                <Select
                  options={employeeOptions}
                  value={employeeOptions.find((opt) => opt.value === formData.employee_id)}
                  onChange={handleEmployeeChange}
                  placeholder="Select Employee"
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                    }),
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-medium text-primary-dark">
                  Date
                </Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  className="radius-8"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-medium text-primary-dark">
                  Check In Time
                </Form.Label>
                <Form.Control
                  type="time"
                  name="check_in"
                  value={formData.check_in}
                  onChange={handleInputChange}
                  className="radius-8"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-medium text-primary-dark">
                  Check Out Time
                </Form.Label>
                <Form.Control
                  type="time"
                  name="check_out"
                  value={formData.check_out}
                  onChange={handleInputChange}
                  className="radius-8"
                  required
                />
              </Form.Group>
              <div className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  type="submit"
                  className="text-md px-24 py-8 radius-8"
                  disabled={loading}
                >
                  <Icon fontSize={22} icon="mdi:check" className="me-2" />
                  {loading ? "Submitting..." : "Submit Attendance"}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default AddManualAttendancePage;